import { ReactNode } from 'react';
import { Col, Row, Switch } from 'antd';
import { useTheme } from 'styled-components';
import { CurrencyInput } from 'components/CurrencyInput';
import { TextS } from 'components/Text';
import { isApprovalLimitInvalid } from 'helpers/currency';

interface IApprovalLimitFieldProps {
	value: string | number;
	active: boolean;
	onChangeValue: (value: string | number) => void;
	onChangeActive: (active: boolean) => void;
	/** ações opcionais (ex.: botão "Salvar alterações" no editar) na linha do aviso */
	footer?: ReactNode;
}

/**
 * Caixa do limite de aprovação por transação (compartilhada entre criar e editar acesso).
 * O switch é rotulado "Sem limite / por transação" => inverso de `active` (só apresentação;
 * `active` é o domínio). O input de valor fica habilitado apenas quando `active`.
 */
export const ApprovalLimitField = ({
	value,
	active,
	onChangeValue,
	onChangeActive,
	footer,
}: IApprovalLimitFieldProps) => {
	const theme = useTheme();
	const invalid = isApprovalLimitInvalid(active, value);

	return (
		<div
			style={{
				background: theme.primaryOpacity,
				borderRadius: '6px',
				padding: '12px 16px',
			}}
		>
			<TextS color={theme.primary} weight="bold">
				Limite de aprovação
			</TextS>
			<Row align="middle" gutter={12} style={{ marginTop: '4px' }}>
				<Col flex="auto" style={{ maxWidth: '220px' }}>
					<CurrencyInput
						placeholder="0,00"
						disabled={!active}
						value={value}
						onChange={v =>
							onChangeValue(v as unknown as string | number)
						}
					/>
				</Col>
				<Col>
					<Switch
						disabled={false}
						checked={!active}
						onChange={checked => onChangeActive(!checked)}
					/>
				</Col>
				<Col>
					<TextS
						weight="normal"
						style={{
							whiteSpace: 'pre-line',
							lineHeight: 1.1,
							fontSize: '11px',
						}}
					>
						{'Sem limite\npor transação'}
					</TextS>
				</Col>
			</Row>
			<TextS
				color={theme.textGray}
				style={{ display: 'block', marginTop: '4px' }}
			>
				Valor máximo por transação para aprovações deste usuário.
			</TextS>
			<Row
				justify="space-between"
				align="middle"
				style={{ marginTop: '8px', minHeight: '32px' }}
			>
				<Col flex="auto">
					{invalid && (
						<TextS color={theme.danger}>
							Limite deve ser maior que zero quando ativo.
						</TextS>
					)}
				</Col>
				{footer && <Col>{footer}</Col>}
			</Row>
		</div>
	);
};
